import { css } from "@emotion/react";

import { QuestPoint } from "~/domains/quest/lib";

const FussyPointLabel = ({ point }: { point: QuestPoint }) => {
  return (
    <p css={questDetailPointDescriptionStyle}>
      <span>FUSSY POINT</span>
      <span css={questDetailPointTipStyle}>{point.value}pt</span>
    </p>
  );
};

const questDetailPointDescriptionStyle = css`
  display: flex;
  gap: 0.5rem;
  margin: 0;
  font-size: 0.5625rem;
  font-weight: 700;
`;

const questDetailPointTipStyle = css`
  display: inline-block;
  padding-inline: 0.25rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 4px;
  background: linear-gradient(92deg, #78ffa6 5.32%, #90bdff 96.36%);
`;

export default FussyPointLabel;
